const MONTHS_SHORT: Record<string, string> = {
  '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr',
  '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug',
  '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec',
};

/** Извлекает дату экспирации из символа в формате YYYYMMDD (год-месяц-день). */
export function extractOptionExpiry(symbol: string): string {
  const parts = symbol.split('-');
  return parts.length >= 2 && /^\d{8}$/.test(parts[1]) ? parts[1] : '';
}

/** Извлекает тип опциона (C/P) из последней части символа. */
export function extractOptionSide(symbol: string): 'C' | 'P' | '' {
  const parts = symbol.split('-');
  const side = parts[parts.length - 1];
  return side === 'C' || side === 'P' ? side : '';
}

/** Извлекает базовый актив (BTC, ETH, …) из символа. */
export function extractOptionBase(symbol: string): string {
  const rawBase = symbol.split('-')[0] ?? '';
  return rawBase.includes('_') ? rawBase.split('_')[0] : rawBase;
}

/** Форматирует дату YYYYMMDD → DD MMM YY. */
export function fmtOptionExpiry(raw: string): string {
  if (raw.length !== 8) return raw;
  const yr = raw.slice(2, 4);
  const mon = MONTHS_SHORT[raw.slice(4, 6)] ?? raw.slice(4, 6);
  const day = raw.slice(6, 8);
  return `${day} ${mon} ${yr}`;
}
